export function isNumber(type) {
  const numberTypes = [
    'decimal',
    'integer',
    'bigint',
    'numeric',
    'float',
    'real',
  ]
  return numberTypes.includes(type)
}

export function isText(type) {
  const textTypes = ['text', 'json', 'uuid', 'table']
  return textTypes.includes(type)
}

export function isDate(type) {
  return ['date', 'timestamp'].includes(type)
}

export function isBoolean(type) {
  return type === 'boolean'
}

export function getIcon(type) {
  switch (true) {
    case isText(type):
      return 'alphabetical'
    case isDate(type):
      return 'calendar'
    case isNumber(type):
      return 'numeric'
    case isBoolean(type):
      return 'toggle-switch'
    default:
      return 'help'
  }
}
